/**
 * Created by rak on 4/28/2017.
 */

'use strict';

angular.module('betosyswebapp')
  .directive('jqxDeleteDirective', function () {
    return {
      restrict: 'A',
      priority: 1000,
      scope: {
        jqxDeleteDirective: '@',
        type: '@'
      },
      link: function (scope, element) {
        var isWidgetIsinfullScreen = $(element).closest('.widget-fullscreen').length > 0 ? true : false;
        element.on('$destroy', function () {
          if (scope.type && scope.jqxDeleteDirective && !isWidgetIsinfullScreen) {
            var tmp;
            switch (scope.type) {
              // try catch necessary for not interrupting element destruction on error.
              // its possible jqx destroy may throw error when destroy called if  JQX-create attribute is false by default or the element inside a tab.
              case 'grid':
                if ($('body.modal-open').length - 1) {
                  try {
                    tmp = $('#' + scope.jqxDeleteDirective);
                    if (tmp.length > 0) {
                      tmp.jqxGrid('destroy');
                    }
                  }
                  catch (err) {
                    console.log(err);
                  }
                }

                break;
              case 'comboBox':
                try {
                  tmp = $('#' + scope.jqxDeleteDirective);
                  if (tmp.length > 0) {
                    tmp.jqxComboBox('destroy');
                  }
                }
                catch (err) {
                  console.log(err);
                }
                break;
              case 'dropDownList':
                try {
                  tmp = $('#' + scope.jqxDeleteDirective);
                  if (tmp.length > 0) {
                    tmp.jqxDropDownList('destroy');
                  }
                }
                catch (err) {
                  console.log(err);
                }
                break;
              case 'chart':
                try {
                  tmp = $('#' + scope.jqxDeleteDirective);
                  if (tmp.length > 0) {
                    tmp.jqxChart('destroy');
                  }
                }
                catch (err) {
                  console.log(err);
                }
                break;
              case 'rangeSelector':
                try {
                  tmp = $('#' + scope.jqxDeleteDirective);
                  if (tmp.length > 0) {
                    tmp.jqxRangeSelector('destroy');
                  }
                }
                catch (err) {
                  console.log(err);
                }
                break;
            }
          }

        });

      }
    };
  });




// WEBPACK FOOTER //
// ./.tmp/components/common/directives/deleteDirective.js